// Types for the process execution framework (Configuração › Operações).
// Mirrors the ERPApi domain JSON (camelCase). See ERPApi/docs/funcionalidades/processos-agendados.md.

export interface Process {
  id: number;
  processKey: string;
  name: string;
  description: string | null;
  scheduledTime: string | null; // "HH:MM" or null (on-demand only)
  executionMode: number; // 1=Automatic 2=ManualApproval
  isActive: boolean;
}

export interface ProcessExecution {
  id: number;
  processId: number;
  processKey?: string;
  processName?: string;
  executionDate: string; // "YYYY-MM-DD"
  triggerType: number; // 1=Scheduled 2=Manual
  status: number; // ExecStatus
  startedAt: string | null;
  finishedAt: string | null;
  totalTargets: number;
  successCount: number;
  failureCount: number;
  skippedCount: number;
  /** Ações com status Alerta: pedem ação humana, mas não são falha do processo. */
  alertCount?: number;
  errorMessage: string | null;
  triggeredBy: string | null;
  approvedBy: string | null;
  approvedAt: string | null;
}

export interface ProcessAction {
  id: number;
  processExecutionId: number;
  processId: number;
  executionDate: string;
  targetType: number | null;
  targetRef: string | null;
  targetLabel: string | null;
  dedupKey: string | null;
  isApproved: boolean;
  status: number; // ActionStatus
  errorMessage: string | null;
  processedAt: string | null;
}

export interface ProcessUpdatePayload {
  scheduledTime?: string | null;
  executionMode?: number;
  isActive?: boolean;
}

// Optional per-run inputs for a manual execution (POST /processes/:id/run body).
// Only specific processes consume these (e.g. bi_daily reads reprocessDates).
export interface ProcessRunPayload {
  reprocessDates?: string[]; // "YYYY-MM-DD"
  // Intervalo de dias a reprocessar (inclusivo nas duas pontas). O backend
  // expande o intervalo em dias e os trata como reprocessDates.
  reprocessFrom?: string; // "YYYY-MM-DD"
  reprocessTo?: string; // "YYYY-MM-DD"
}

// ProcessKey values the UI special-cases (custom run inputs, etc.).
export const ProcessKey = {
  BIDaily: 'bi_daily',
} as const;

export const ProcessMode = {
  Automatic: 1,
  ManualApproval: 2,
} as const;

export const ExecStatus = {
  Pending: 0,
  Running: 1,
  Success: 2,
  PartialError: 3,
  Failed: 4,
  AwaitingApproval: 5,
  Cancelled: 6,
} as const;

export const ActionStatus = {
  Pending: 0,
  Success: 1,
  Failed: 2,
  Skipped: 3,
  /** O alvo pede ação humana (ex.: pendência de recebível Cielo) — não é falha. */
  Alert: 4,
} as const;

export const TriggerType = {
  Scheduled: 1,
  Manual: 2,
} as const;
